import type { LuckPaperMode } from "./print-modes";
import {
  buildEnablePrinterCommand,
  buildWakeCommand,
  DEFAULT_FEED_DOTS,
  WEB_BLE_CHUNK_DELAY_MS,
  WEB_BLE_CHUNK_SIZE,
} from "./protocol";

export type DeviceProfileId = "luck-d1" | "luck-dp-l1s" | "generic-luck";

export type DeviceProfile = {
  id: DeviceProfileId;
  label: string;
  printWidthPx: number;
  chunkSize: number;
  chunkDelayMs: number;
  enableSequence: Uint8Array[];
  defaultFeedDots: number;
  suggestedPaperMode: LuckPaperMode;
  /** @deprecated Use suggestedPaperMode */
  suggestedPrintMode: LuckPaperMode;
};

const GENERIC_ENABLE_SEQUENCE = [
  buildEnablePrinterCommand(),
  buildWakeCommand(),
];

export const DEVICE_PROFILES: Record<DeviceProfileId, DeviceProfile> = {
  "generic-luck": {
    id: "generic-luck",
    label: "Luck ທົ່ວໄປ (384px)",
    printWidthPx: 384,
    chunkSize: WEB_BLE_CHUNK_SIZE,
    chunkDelayMs: WEB_BLE_CHUNK_DELAY_MS,
    enableSequence: GENERIC_ENABLE_SEQUENCE,
    defaultFeedDots: DEFAULT_FEED_DOTS,
    suggestedPaperMode: "continuous",
    suggestedPrintMode: "continuous",
  },
  "luck-dp-l1s": {
    id: "luck-dp-l1s",
    label: "DP-L1S / C&Co 3128",
    printWidthPx: 384,
    chunkSize: WEB_BLE_CHUNK_SIZE,
    chunkDelayMs: WEB_BLE_CHUNK_DELAY_MS,
    enableSequence: GENERIC_ENABLE_SEQUENCE,
    defaultFeedDots: DEFAULT_FEED_DOTS,
    suggestedPaperMode: "label-gap",
    suggestedPrintMode: "label-gap",
  },
  "luck-d1": {
    id: "luck-d1",
    label: "Luck D1",
    printWidthPx: 384,
    chunkSize: WEB_BLE_CHUNK_SIZE,
    chunkDelayMs: WEB_BLE_CHUNK_DELAY_MS,
    enableSequence: GENERIC_ENABLE_SEQUENCE,
    defaultFeedDots: DEFAULT_FEED_DOTS,
    suggestedPaperMode: "label-gap",
    suggestedPrintMode: "label-gap",
  },
};

export const DEVICE_PROFILE_OPTIONS = (
  Object.values(DEVICE_PROFILES) as DeviceProfile[]
).map((profile) => ({
  value: profile.id,
  label: profile.label,
}));

export function getDeviceProfile(id: DeviceProfileId): DeviceProfile {
  return DEVICE_PROFILES[id];
}

export function resolveDeviceProfile(
  id?: DeviceProfileId | null,
): DeviceProfile {
  if (id && id in DEVICE_PROFILES) return DEVICE_PROFILES[id];
  return DEVICE_PROFILES["generic-luck"];
}
